<template>
  <section>
    <div class="access-stats-summary">
      <!-- 文件动态标题 -->
      <span>{{ $t('文件动态') }}</span>

      <!-- 下拉菜单 -->
      <el-dropdown
        ref="dateMenu"
        trigger="click"
        class="access-stats-select"
        @command="selectDay"
        @visible-change="changeIcon"
      >
        <span class="el-dropdown-link">
          {{ $t(currentDay.value) }}<i
            :class="[isDown ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"
            class="el-icon--right"
          />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="day in days"
            :key="day.id"
            :command="day"
          >
            {{ $t(day.value) }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>


      <div
        v-loading="loading"
        class="access-stats-list"
        :element-loading-text="$t('正在加载')"
        element-loading-spinner="icon-loading"
      >
        <ul>
          <li
            v-for="(item,index) in dynamics"
            :key="index"
            class="access-stats-item"
            @click="dialogHandle(item.action)"
          >
            <i
              class="dynamic-icon"
              :class="item.action"
            />
            <span><span>{{ $t(item.actionName) }}</span></span>
            <span class="access-stats-num">{{ item.count }}</span>
          </li>
        </ul>
      </div>
      <span
        class="acccess-stats-more"
        @click="dialogHandle('all')"
      >{{ $t('查看详情') }}</span>
    </div>


    <co-dialog
      v-model="visible"
      :title="getTitle"
      height="500"
      @close="visible = false"
    >
      <span slot="title" class="file-dynamic-title">
        <el-tooltip
          class="item"
          effect="dark"
          :content="getTitle"
          placement="top"
        >
          <span class="dy-title txt-o">{{getTitle}}</span>
        </el-tooltip>
        <span>{{ $t('动态详情') }}</span>
      </span>
      <dynamic-dialog
        :visible="visible"
        :list-type="listType"
        :current-day="newCurrentDay"
        :dynamics="newDynamics"
        @closeDialog="visible = false"
        @getMeta="getMeta"
        @changeListType="changeListType"
      />
      <div
        slot="button"
        class="dynamic-dialog-footer"
      >
        <button
          class="lv-btn default-btn c-btn"
          @click="visible = false"
        >
          {{ $t('关闭') }}
        </button>
      </div>
    </co-dialog>
  </section>
</template>

<script>
import * as Util from 'js/util/util.js'
import coDialog from 'components/common/dialog/index.vue'
import store from 'store'
import dynamicDialog from './dynamic-dialog.vue'

const { getData } = require('js/api/getdata').default

export default {
  components: {
    dynamicDialog,
    coDialog,
  },
  data() {
    return {
      days: [
        { id: '7', value: this.$t('7天内') },
        { id: '15', value: this.$t('15天内') },
        { id: '30', value: this.$t('30天内') },
        { id: '45', value: this.$t('45天内') },
        { id: '60', value: this.$t('60天内') },
      ],
      currentDay: {
        id: 15,
        value: this.$t('15天内'),
      },
      newCurrentDay: {
        id: 15,
        value: this.$t('15天内'),
      },
      showDialog: false,
      dynamics: [
        { actionName: this.$t('预览'), action: 'preview', count: 0 },
        { actionName: this.$t('更新'), action: 'modify', count: 0 },
        { actionName: this.$t('下载'), action: 'download', count: 0 },
        { actionName: this.$t('评论'), action: 'comment', count: 0 },
      ],
      newDynamics: [ // 弹框和右侧的数据不需要绑定更新，所以使用newDynamics传递数据，弹框中更改时间时不影响右侧的数据展示
        { actionName: this.$t('预览'), action: 'preview', count: 0 },
        { actionName: this.$t('更新'), action: 'modify', count: 0 },
        { actionName: this.$t('下载'), action: 'download', count: 0 },
        { actionName: this.$t('评论'), action: 'comment', count: 0 },
      ],
      loading: true,
      isDown: true,
      listType: 'all',
      visible: false,
    }
  },
  computed: {
    /**
         * 获取当前查看文件的信息
         */
    selectedData() {
      return store.state.curFileInfo
    },
    /**
         * 获取弹框的标题
         */
    getTitle() {
      return `${Util.resolvePath(this.selectedData.path).name}`
    },
  },
  watch: {
    selectedData(val) {
      this.currentDay = {
        id: 15,
        value: this.$t('15天内'),
      }
      this.getMeta()
    },
  },
  mounted() {
    this.getMeta()
  },
  methods: {
    /**
         * 获取动态详情相关的信息
         */
    getMeta(day) {
      const params = {
        days: day && day.id || this.currentDay.id,
        neid: this.selectedData.neid,
        nsid: this.selectedData.nsid,
      }
      if (!params.neid) {
        return
      }
      if (day && day.id) {
        this.newCurrentDay = day
      }
      getData('fileDynamics', params).then((ret) => {
        this.loading = false
        const { data } = ret

        this.newDynamics[0].count = data.previewCount > 999 ? '999+' : data.previewCount
        this.newDynamics[1].count = data.modifyCount > 999 ? '999+' : data.modifyCount
        this.newDynamics[2].count = data.downloadCount > 999 ? '999+' : data.downloadCount
        this.newDynamics[3].count = data.commentCount > 999 ? '999+' : data.commentCount

        if (!day) { // dialog中选择时间时，不更改右侧数据
          this.dynamics[0].count = data.previewCount > 999 ? '999+' : data.previewCount
          this.dynamics[1].count = data.modifyCount > 999 ? '999+' : data.modifyCount
          this.dynamics[2].count = data.downloadCount > 999 ? '999+' : data.downloadCount
          this.dynamics[3].count = data.commentCount > 999 ? '999+' : data.commentCount
        }
      }).catch((err) => {
        this.loading = false
      })
    },

    selectDay(day) {
      this.currentDay = day
      this.loading = true
      this.getMeta()
    },
    /**
         * 查看不同记录的详情
         */
    dialogHandle(type) {
      this.getMeta()
      this.$nextTick(() => {
        this.newCurrentDay = this.currentDay
        this.listType = type
        this.visible = true
      })
    },
    changeIcon(v) {
      this.isDown = !v
    },
    changeListType(type) {
      this.listType = type
    },
    hideDateMenu() {
      this.$refs.dateMenu.hide()
    },
  },
}
</script>

<style lang="less" scoped>
.file-dynamic-title{
  span{
    line-height: 24px;
    vertical-align: top;
  }
}
.dy-title {
  max-width: 300px;
  display: inline-block;
}

.txt-o {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dynamic-dialog-footer {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.default-btn {
  border: 1px solid #C1C7CD;
  border-radius: 2px;
  width: 80px;
  height: 38px;
  background: white;
  cursor: pointer;
}
.default-btn:hover {
  background: #e8ebef;
}
.access-stats-summary {
  margin-top: 16px;
  margin-bottom: 28px;
  color:#404040;
  .access-stats-select{
    color: #404040;
    float: right;
    cursor: pointer;
  }.access-stats-list {
    margin-bottom: 8px;
    .access-stats-item {
      background: #F6F7FA;
      height: 32px;
      line-height: 32px;
      margin-top: 8px;
      border-radius: 2px;
      cursor: pointer;
    }
    .dynamic-icon{
      float: left;
      height: 15px;
      margin: 11px 13px 0 13px;
      width: 16px;
    }
    .preview{
      background-image:url("../images/preview.svg");
      background-repeat: no-repeat
    }
    .download{
      background-image:url("../images/download.svg");
      background-repeat: no-repeat
    }
    .comment{
      background-image:url("../images/comment.svg");
      background-repeat: no-repeat
    }
    .modify{
      background-image:url("../images/modify.svg");
      background-repeat: no-repeat
    }
    .access-stats-num{
      float: right;
      padding-right: 12px;
    }
  }
  .icon-loading{
    background-image:url("~image/search-load.gif");
  }
  .acccess-stats-more{
    margin-top: 8px;
    color: #0A64FA;
    cursor: pointer;
  }
}

</style>
